/**
 * @module lib/data Utilities for working with data
 */
export * from './Model.js';
